import React from "react";
import { createRoot } from "react-dom/client";
import AccountSetDialog from "@/app/csr-src/pages/profile/personalCenter/personalAccountSetDialog/index";
import { getTranslatedCookiesSettings } from "@/app/csr-src/data/consts/accountEnum";
export default class AddEmailController {

  root = null;
  element = null;
  isOpen = false;
  flagParams = null;
  
  constructor() {

    this.element = document.createElement("div");
    document.body.appendChild(this.element);

    this.handleClose = () => {
      this.isOpen = false;
      if (this.root) {
        this.root.unmount();
        this.root = null;
      }
      if (this.element && document.body.contains(this.element)) {
        document.body.removeChild(this.element);
      }
    };
    
    let translationSetting = getTranslatedCookiesSettings((key) => {});
    this.flagParams = {
      defaultFlag: translationSetting.AccountTypeEnum.ADD_EMAIL,
      defaultDialogFlag: translationSetting.AccountTypeEnum.EMAIL_VERIFICATION,
      defaultDialogTitleKey: "settings.emailInfo.addEmail",
    };

  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new AddEmailController();
    }
    return this.instance;
  }

  async openAddEmailDialog() {
    if (this.isOpen) 
      return;
    this.isOpen = true;
    try {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      this.root.render(
        React.createElement(AccountSetDialog, { 
          open: this.isOpen,
          flagParams: this.flagParams,
          onlyClose: this.handleClose,
        })
      );
    } catch (error) {
      this.isOpen = false;
      console.error("Failed to render add email dialog:", error);
    }
  }
}